import * as React from 'react';

interface ICommandPaletteContextValue {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const CommandPaletteContext = React.createContext<ICommandPaletteContextValue | undefined>(undefined);

/** Whether the command palette is open, and the setter any control can open it with. */
export const useCommandPalette = (): ICommandPaletteContextValue => {
  const ctx = React.useContext(CommandPaletteContext);
  if (!ctx) {
    throw new Error('useCommandPalette must be used inside a CommandPaletteProvider');
  }
  return ctx;
};

interface ICommandPaletteProviderProps {
  children: React.ReactNode;
}

/**
 * Owns the command palette's open state, so a control outside the palette —
 * the header's search box — can open it. Mounted once in `MainApp`, above the
 * palette and every route.
 */
const CommandPaletteProvider = ({ children }: ICommandPaletteProviderProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const value = React.useMemo(() => ({ isOpen, setIsOpen }), [isOpen]);
  return <CommandPaletteContext.Provider value={value}>{children}</CommandPaletteContext.Provider>;
};

export default CommandPaletteProvider;
